import { Alert, Button, CircularProgress, Container, Grid, TextField } from "@mui/material";
import React, { useEffect, useState } from "react";

import { TermsOfServiceFields, useAcceptTerms } from "api/services/useAuth";
import { TERMS_OF_SERVICE_TEXT, TERMS_OF_SERVICE_VERSION } from "config/copies/termsOfServiceAssets";
import { useAppSelector } from "hooks/store";
import { getUserState } from "store/slices/Auth/authSlice";

export function TermsOfService() {
  const userInfo = useAppSelector(getUserState);
  const [termsInput, setTermsInput] = useState<TermsOfServiceFields>({
    accepted_terms_of_service: TERMS_OF_SERVICE_VERSION,
  });

  const acceptTermsMutation = useAcceptTerms(userInfo?.id || "");
  const { data, error, isLoading } = acceptTermsMutation;

  const acceptIsReady = !!termsInput.accepted_terms_of_service && !!termsInput.name && !!termsInput.company;

  async function onClickAccept() {
    if (acceptIsReady) {
      await acceptTermsMutation.mutateAsync(termsInput);
    }
  }

  const status = error || isLoading ? <CircularProgress size={25} /> : null;

  useEffect(() => {
    if (data?.accepted_terms_of_service && !error && !isLoading) {
      window.open("/reef?modal_success=true", "_self");
    }
  }, [data, error, isLoading]);

  return (
    <Container>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Alert severity="info">
            In order to use our services, you must read and accept our terms. You can &quot;Accept&quot; at the bottom
            of this page.
          </Alert>
        </Grid>
        <Grid item xs={12}>
          <pre className="font-mono">{TERMS_OF_SERVICE_TEXT}</pre>
        </Grid>
        {status || (
          <Grid item xs={12}>
            <Grid container spacing={1} alignItems="center">
              <Grid item>
                <TextField
                  label="Name"
                  value={termsInput.name}
                  onChange={(e) => setTermsInput({ ...termsInput, name: e.target.value })}
                />
              </Grid>
              <Grid item>
                <TextField
                  label="Company"
                  value={termsInput.company}
                  onChange={(e) => setTermsInput({ ...termsInput, company: e.target.value })}
                />
              </Grid>
              <Grid item>
                <Button variant="contained" onClick={() => onClickAccept()} disabled={!acceptIsReady}>
                  Accept
                </Button>
              </Grid>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Container>
  );
}
